import { EventEmitter } from 'eventemitter3';
import axios, { type AxiosError } from 'axios';

import type { IPublicClientApplication } from '@azure/msal-browser';
import { axiosInstance } from '@/axiosInstance.ts';
import { checkIsOutdated } from '@/app/utils/buildVersion.ts';

const emitter = new EventEmitter();
export const CLIENT_CLOSED_REQUEST_STATUS = 499;

export function getUrlFromSwaggerUrl(urlWithSwagger: string | undefined): string {
  return !!urlWithSwagger
    ? `${urlWithSwagger.startsWith('https') ? 'https' : 'http'}://${urlWithSwagger.split('//')[1].split('/')[0]}`
    : '';
}

export const shouldEmitInterceptorError = (error: AxiosError) => {
  if (!error.response) {
    return false;
  }

  if (error.response.status === CLIENT_CLOSED_REQUEST_STATUS) {
    return false;
  }

  if (!error.config?.url) {
    return true;
  }

  const status = error.response.status;
  if (status !== 404) {
    return true;
  }

  const url = error.config.url;
  return !url.includes('/api/DialogStatistics/') || !url.endsWith('/notes');
};

const setAccessTokenRequestInterceptor = (instance: IPublicClientApplication) => {
  // const onRequest = async (config: AxiosRequestConfig) => {

  // const onRequest = async (config: AxiosRequestConfig) => {
  //   console.log('on request');
  //   const response = await acquireTokenSilent({ ...loginRequest, account: accounts[0] });

  //   config.headers.Authorization = `Bearer ${response.accessToken}`;

  //   return config;
  // };

  const onResponseError = (error: AxiosError) => {
    const rejection = Promise.reject(error);

    if (!error.response) return rejection;

    // A 5xx may mean this tab runs an old frontend against a newer backend. Check (throttled,
    // fire-and-forget) whether a newer build is deployed; VersionChecker surfaces the result.
    if (error.response.status >= 500 && !axios.isCancel(error)) {
      void checkIsOutdated();
    }

    if (shouldEmitInterceptorError(error)) {
      emitter.emit('Interceptor error', error.response);
    }

    // if (error.response.status === StatusCodes.UNAUTHORIZED) {
    //   instance.logout({ postLogoutRedirectUri: window.location.origin });
    //   return rejection;
    // }

    return rejection;
  };

  // axiosInstance.interceptors.request.use(onRequest, null);
  axiosInstance.interceptors.response.use(null, onResponseError);
};

export const initializeApiClients = (instance: IPublicClientApplication): void => {
  const basePath = getUrlFromSwaggerUrl(process.env.REACT_APP_SCENES);

  setAccessTokenRequestInterceptor(instance);
};

export { emitter, axiosInstance };
